import { render, staticRenderFns } from "./AtomIconLinkButton.vue?vue&type=template&id=3eedfeef&scoped=true"
import script from "./AtomIconLinkButton.vue?vue&type=script&lang=ts"
export * from "./AtomIconLinkButton.vue?vue&type=script&lang=ts"
import style0 from "./AtomIconLinkButton.vue?vue&type=style&index=0&id=3eedfeef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eedfeef",
  null
  
)

export default component.exports